module.exports = __webpack_public_path__ + "static/media/termopary10kz.33df48ad.pdf";